module.exports = __webpack_public_path__ + "static/media/image (11).4b399d4f.jpg";